<div class="appointment-table">
  <img src="../../../assets/logo.png" alt="Logo">
  <!-- <h2>{{ clinicName }}</h2> -->
  <p>Member Name: <b>{{ memberName }}</b><br/>
  Start Date: <b>{{moment(startDate,'DD/MM/YYYY').format('LL')}}</b> <br/>End Date: <b>{{moment(endDate,'DD/MM/YYYY').format('LL')}}</b></p>
  <table>
    <tr>
      <th>Appointment Number</th>
      <th>appointment Date</th>
      <th>Patient Name</th>
      <!-- <th>Patient Phone No</th> -->
      <th>Amount</th>
      <th>Deposit</th>
      <th>Balance</th>
    </tr>
    <tr *ngFor="let appointment of appointments">
      <td>{{ appointment.appointment.appointmentNumber }}</td>
      <th>{{ moment(appointment.appointment.appointmentDate).format('DD/MM/YYYY') }}</th>
      <td>{{ appointment.appointment.patientName }}</td>
      <!-- <td>{{ }}</td> -->
      <td>{{ appointment.amount }}</td>
      <td>{{ appointment.deposit }}</td>
      <td>{{ appointment.balance }}</td>
    </tr>
  </table>
</div>
